export type GeoLocationType =
  | "country"
  | "FO"
  | "subject"
  | "city"
  | "district"
  | "street"
  | "house";

export const GEO_LOCATION_TYPES: GeoLocationType[] = [
  "country",
  "FO",
  "subject",
  "city",
  "district",
  "street",
  "house",
];

export interface IGeoLocationsParams {
  parentId?: number | null;
  type: GeoLocationType;
  name: string;
  nameEn: string;
  socr?: string;
  cladrCode?: string;
  okatoCode?: string;
  index?: string;
  fiasId?: string;
  fiasValue?: string;
  active: boolean;
}

export interface IGeoLocationsEditParams extends IGeoLocationsParams {
  id: number;
}

/**
 * Параметры запроса списка гео-мест (GET /geo/places).
 * Пустые значения не должны передаваться в URL.
 */
export interface IGeoPlacesQueryParams {
  page?: number;
  count?: number;
  id?: number | string;
  parentId?: number | string;
  name?: string;
  nameEn?: string;
  cladrCode?: string;
  okatoCode?: string;
  index?: string;
  type?: GeoLocationType;
  socr?: string;
  fiasId?: string;
  fiasValue?: string;
  active?: boolean;
}

/**
 * Элемент списка, возвращаемого GET /geo/places.
 */
export interface IGeoPlaceItem {
  id: number;
  parentId: number | null;
  type: GeoLocationType;
  name: string;
  nameEn?: string | null;
  socr?: string | null;
  index?: string | null;
  cladrCode?: string | null;
  okatoCode?: string | null;
  fiasId?: string | null;
  fiasValue?: string | null;
  active: boolean;
  createdAt?: string;
  updatedAt?: string;
}

/**
 * Ответ REST-метода GET /geo/places.
 */
export interface IGeoPlacesResponse {
  items: IGeoPlaceItem[];
  total: number;
  count?: number;
  page?: number;
  totalPage?: number;
}
